export function bloodFormat(bloodType: string) {
  switch (bloodType) {
    case 'WHOLE':
      return '전혈';
    case 'PLATELET':
      return '혈소판헌혈';
    case 'LEUKOCYTE':
      return '백혈구헌혈';
    case 'PACKED_RED_BLOOD_CELL':
      return '농축적혈구';
    case 'LEUKOCYTE_REDUCED_RED_BLOOD_CELL':
      return '백혈구제거적혈구';
  }
}

export function categoryFormat(categoryType: string) {
  switch (categoryType) {
    case 'DONATION_EXPIRED':
      return '사연 만료';
    case 'DONATION':
      return '헌혈요청';
    case 'BOARD':
      return '커뮤니티';
    case 'BLOOD_HOME_REVIEW':
      return '헌혈의집ㆍ카페 리뷰';
    case 'FREE':
      return '일상게시판';
    case 'BLOOD_DONATION_REVIEW':
      return '헌혈후기';
    case 'QNA':
      return '헌혈정보게시판';
  }
}

export function bloodProduct(bloodType: string) {
  switch (bloodType) {
    case '전혈':
      return 'WHOLE';
    case '혈소판헌혈':
      return 'PLATELET';
    case '백혈구헌혈':
      return 'LEUKOCYTE';
    case '농축적혈구':
      return 'PACKED_RED_BLOOD_CELL';
    case '백혈구제거적혈구':
      return 'LEUKOCYTE_REDUCED_RED_BLOOD_CELL';
  }
}

export function bloodProductSort(bloodType: string) {
  switch (bloodType) {
    case '헌혈 종류':
      return '';
    case '전혈 (RBC,F-RBC,WB)':
      return 'WHOLE';
    case '혈소판헌혈 (A-PLT,A-PLT[M]':
      return 'PLATELET';
    case '백혈구헌혈':
      return 'LEUKOCYTE';
    case '농축적혈구':
      return 'PACKED_RED_BLOOD_CELL';
    case '백혈구제거적혈구':
      return 'LEUKOCYTE_REDUCED_RED_BLOOD_CELL';
  }
}

export function aboSort(abo: string) {
  switch (abo) {
    case '혈액형':
      return '';
    case 'A+':
      return 'A';
    case 'A-':
      return 'A';
    case 'B+':
      return 'B';
    case 'B-':
      return 'B';
    case 'O+':
      return 'O';
    case 'O-':
      return 'O';
    case 'AB+':
      return 'AB';
    case 'AB-':
      return 'AB';
  }
}

export function sort(type: string) {
  switch (type) {
    case '최신순':
      return 'LAST_RENEWED_AT';
    case '헌혈인증순':
      return 'BLOOD_DONATION';
    case '응원하기순':
      return 'LIKE';
  }
}

export async function copyClipBoard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (e: any) {
    throw new Error(e);
  }
}

export function convertLinksToHyperlinks(text: string) {
  const pattern = /https?:\/\/\S+/g;
  const replacedContent = text?.replace(pattern, (match) => {
    return `<a style="color:blue; text-decoration: underline" href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
  });
  return { __html: replacedContent };
}
